export interface AppConfig {
  REACT_APP_BEMSIGN_URL: string;
  REACT_APP_BEMSIGN_AUTENTICACAO_URL: string;
  REACT_APP_ANALISE_RISCO_URL: string;
  REACT_APP_PORTAL_EMPRESARIAL_URL: string;
  REACT_APP_KEYCLOAK_SERVER_URL: string;
  REACT_APP_KEYCLOAK_REDIRECT_URL: string;
}

export const loadAppConfig = async (): Promise<void> => {
  //@ts-ignore
  const configUrl =
    process.env.NODE_ENV === "development"
      ? "/config.development.json"
      : "/configs/config.production.json";

  try {
    const response = await fetch(configUrl);
    if (!response.ok) {
      throw new Error(`Erro ao carregar config de ${configUrl}`);
    }

    const config: AppConfig = await response.json();
    //@ts-ignore
    window.CONFIG = config;

  } catch (error) {
    console.error("Erro ao carregar configuração:", error);
  }
};
